import { recordSelectors } from '@skinsoft/entity';
import { Record } from '@skinsoft/entity';
import { Observable, of } from 'rxjs';

export interface RecordFeatured {
    id: string,
    linkedItemId: string,
    recordIdentifier: string,
    currentState: string
    fromUpdateCache: boolean
}

export function toRecordFeatured$(record: Record, locale: string): Observable<RecordFeatured> {
    const featuredrecord: RecordFeatured = {
        currentState: recordSelectors.currentState(record, locale),
        fromUpdateCache: !!record.fromUpdateCache,
        id: recordSelectors.id(record),
        linkedItemId: recordSelectors.linkedItemId(record),
        recordIdentifier: recordSelectors.recordIdentifier(record),
    }

    return of(featuredrecord);
}